/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineIdChannelsChannelid202,
  DeleteApiV1ClassroomdisciplineIdChannelsChannelid401,
  DeleteApiV1ClassroomdisciplineIdChannelsChannelid404,
  DeleteApiV1ClassroomdisciplineIdChannelsChannelidMutationResponse,
  DeleteApiV1ClassroomdisciplineIdChannelsChannelidPathParams,
} from "../../types/classPlanningChannelsController/DeleteApiV1ClassroomdisciplineIdChannelsChannelid.ts";

export const deleteApiV1ClassroomdisciplineIdChannelsChannelidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChannelsChannelidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineIdChannelsChannelid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChannelsChannelid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineIdChannelsChannelid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineIdChannelsChannelid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChannelsChannelid404>;

export const deleteApiV1ClassroomdisciplineIdChannelsChannelidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineIdChannelsChannelid202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChannelsChannelidMutationResponse>;
